import { Box, Button, Dialog, Typography, useMediaQuery, useTheme, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import Styles from "../commonStyles";
import combineStyles from "../_helpers/combineStyles";

const styles = theme => ({
  innerBox: {
    height: '50vh',
    [theme.breakpoints.down('sm')]: {
      width: null,
      height: 'auto'
    },
    [theme.breakpoints.up(1000)]: {
      width: '35vw'
    },
    [theme.breakpoints.up(1750)]: {
      width: '29vw'
    },
    [theme.breakpoints.up(2450)]: {
      width: '21vw'
    },
  },
  image: {
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    },
  }
})

function CommonPopup(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const { classes, popupText, handleClick, openState, buttonText, cancelButtonText, handleCancel } = props;

  return (
    <Dialog
      open={openState}
      onClose={() => { }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box
        display={"flex"}
        flexDirection="column"
        alignItems={"center"}
        justifyContent={"center"}
        // width={!matches ? "30vw" : null}
        // height={!matches ? "45vh" : null}
        padding="10px"
        className={classes.innerBox}
      >
        {/* !matches && */ <img
          // style={{ width: "100%", height: "100%" }}
          className={classes.image}
          src="../images/popup1.svg"
        />}

        <Typography style={{
          margin: "5 0",
          textAlign: 'center',
          lineHeight: 1,
          margin: '5px 0px 12px',
        }}>
          {popupText || "This is dummy text"}
        </Typography>
        <Box>
          {cancelButtonText && <Button
            variant="outlined"
            className={classes.popupCancelButton}
            onClick={handleCancel}
            type="button"
          >
            {cancelButtonText || "CANCEL"}
          </Button>}
          <Button
            variant="contained"
            className={classes.popupbutton}
            onClick={handleClick}
            type="button"
            autoFocus={true}
          >
            {buttonText || "OK"}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}

CommonPopup.propTypes = {
  openState: PropTypes.bool,
};

CommonPopup.defaultProps = {
  openState: false,
};

export default withStyles(combineStyles(Styles, styles))(CommonPopup);
